import { render } from "./StorageConfig.vue?vue&type=template&id=0cff4caa&scoped=true"
import script from "./StorageConfig.vue?vue&type=script&lang=js"
export * from "./StorageConfig.vue?vue&type=script&lang=js"

import "./StorageConfig.vue?vue&type=style&index=0&id=0cff4caa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cff4caa"]])

export default __exports__